import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import ".././App.css";
import { Button, Link, Stack, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { useRef } from "react";
import emailjs from "@emailjs/browser";

function Contact() {
  let onDownload = () => {
    let link = document.createElement("a");
    link.download = `resume.pdf`;
    link.href =
      "https://drive.google.com/file/d/1QrxqulPIM1VGKamo138-FW1ag9OmnXR_/view?usp=sharing";
    link.click();
  };
  let useStyles = makeStyles({
    resume: {
      "&:hover": {
        backgroundColor: "#610131",
      },
    },
  });

  let classes = useStyles();
  const form = useRef();

  const sendEmail = () => {
    let params = {
      to_name: document.getElementById("name").value,
      to_mail: document.getElementById("email").value,
      message: document.getElementById("message").value,
    };

    emailjs
      .send("service_7emlwbn", "template_3pi2f0m", params, "kxxf7U-neFz1nyBud")
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    emailjs
      .send("service_7emlwbn", "template_vov4xmj", params, "kxxf7U-neFz1nyBud")
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    document.getElementById("name").value = "";
    document.getElementById("email").value = "";
    document.getElementById("message").value = "";
  };

  return (
    <Box
      sx={{
        color: "white",
        margin: "auto",
        backgroundColor: "black",
        boxSizing: "border-box",
        width: "100vw",
        marginTop: { lg: "75px", md: "75px", sm: "30px" },
      }}
    >
      <Box
        sx={{
          width: '90vw',
          margin: "auto",
          textAlign: "justify",
          fontSize: "55px",
          color: "teal",
          boxSizing: "border-box",
          padding: {
            lg: "0px",
            md: "0px",
            sm: "40px 0px 0px 0px",
            xs: "70px 0px 0px 0px",
          },
        }}
      >
        Contacts
        <hr />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            lg: "row",
            md: "column",
            sm: "column",
            xs: "column",
          },
          justifyContent: "space-between",
          gap: {lg:'120px',md:'120px',sm:'120px',xs:'80px'},
          margin: "auto",
          padding: {
            lg: "30px 0px 40px",
            md: "50px 0px",
            sm: "20px 0px",
            xs: "20px 0px",
          },
          width: { lg: "85vw", md: "85vw", sm: "85vw", xs: "85vw" },
        }}
      >
        <Box>
          <Typography
            variant="h4"
            textAlign="left"
            marginLeft="20px"
            letterSpacing={7}
          >
            Send your feedback
          </Typography>
          <Stack
            sx={{
              width: { lg: "500px", md: "500px", sm: "500px", xs: "90vw" },
              height: "200px",
              padding: "50px 0px",
              margin: { sm: "10px", xs: "10px" },
            }}
            gap="40px"
          >
            <TextField
              type="text"
              id="name"
              name="user_name"
              label="Your Name"
              placeholder="Enter Your Name"
              variant="outlined"
              InputLabelProps={{ className: "TextFieldLable" }}
              InputProps={{ className: "TextFieldInput" }}
              required
            />
            <TextField
              type="email"
              id="email"
              name="user_email"
              label="Your Email"
              placeholder="Enter Your Email"
              variant="outlined"
              InputLabelProps={{ className: "TextFieldLable" }}
              inputProps={{ className: "TextFieldInput" }}
              required
            />
            <TextField
              type="text"
              id="message"
              name="message"
              label="Message"
              placeholder="Enter Message"
              variant="outlined"
              InputLabelProps={{ className: "TextFieldLable" }}
              inputProps={{ className: "TextFieldInput" }}
              required
              multiline
              rows={4}
            />
            <Button
              onClick={sendEmail}
              variant="contained"
              sx={{
                width: { lg: "100%", md: "100%", sm: "460px", xs: "80vw" },
                marginBottom: { sm: "15px", xs: "15px" },
              }}
            >
              Send
            </Button>
          </Stack>
        </Box>
        <Box
          sx={{
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            mt: { lg: "0px", md: "150px", sm: "150px", xs: "150px" },
          }}
        >
          <Typography variant="h4" letterSpacing={7}>
            Residential Address
          </Typography>
          <Box
            variant="p"
            fontSize="20px"
            marginTop="10px"
            color="green"
            marginBottom="50px"
            letterSpacing={2}
          >
            Borgaon meghe, Wardha, Maharashtra
            <br />
            442001
          </Box>
          <Typography variant="h4" letterSpacing={7}>
            Email Address
          </Typography>
          <Box
            variant="p"
            fontSize="20px"
            marginTop="10px"
            color="green"
            marginBottom="50px"
            letterSpacing={2}
          >
            pranitkhadse20@gmail.com
          </Box>
          <Box sx={{ textAlign: "left" }}>
            <Typography variant="h4" letterSpacing={7}>
              Mobile Number
            </Typography>
            <Box
              variant="p"
              fontSize="20px"
              marginTop="10px"
              color="green"
              letterSpacing={2}
            >
              8999665378
            </Box>
          </Box>
          <Button
            href="https://mail.google.com/mail/u/0/?fs=1&to=pranitkhadse20@gmail.com&su=SUBJECT&body=BODY&tf=cm"
            variant="contained"
            sx={{
              marginTop: "85px",
              width: { lg: "100%", md: "510px", sm: "460px", xs: "80vw" },
              backgroundColor: "#CC0066",
            }}
            className={classes.resume}
          >
            Contact me via gmail
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Contact;
